import './App.scss'
import { BrowserRouter } from 'react-router'
import Router from './router'

function App() {
  return (
    <>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </>
  )
}

export default App
